const hotelsActiveSites = [
  'AR',
  'AU',
  'CA',
  'CH',
  'CL',
  'CN',
  'CO',
  'CZ',
  'DE',
  'ES',
  'FR',
  'GB',
  'GOFR',
  'GR',
  'HK',
  'HU',
  'ID',
  'IN',
  'IT',
  'JP',
  'KR',
  'MA',
  'MX',
  'NL',
  'NZ',
  'OPAT',
  'OPAU',
  'OPCH',
  'OPDE',
  'OPDK2',
  'OPES',
  'OPFI2',
  'OPFR',
  'OPGB',
  'OPIT',
  'OPNL',
  'OPNO2',
  'OPPL2',
  'OPPT',
  'OPSE2',
  'OPUK',
  'PE',
  'PH',
  'PT',
  'QA',
  'RO',
  'SA',
  'SG',
  'TH',
  'TR',
  'TRDE',
  'TRDK',
  'TRFI',
  'TRGB',
  'TRIS',
  'TRNO',
  'TRSE',
  'TW',
  'UK',
  'US',
  'ZA',
] as const;

export default hotelsActiveSites;
